import { validate as validarCPF } from "gerador-validador-cpf";
import VMasker from "vanilla-masker";
import { toggleCampos, alterarCampos } from "./utils";
import {
    camposMask,
    endpointCep,
    camposCep,
    endpointCnpj,
    camposCnpj,
    estados
} from "./vars";

function inputHandler(masks, max, event) {
    var c = event.target;
    var v = c.value.replace(/\D/g, "");
    var m = c.value.length > max ? 1 : 0;
    VMasker(c).unMask();
    VMasker(c).maskPattern(masks[m]);
    c.value = VMasker.toPattern(v, masks[m]);
}

function initVMasker() {
    for (let c of Object.keys(camposMask)) {
        if (camposMask[c].mask && camposMask[c].el) {
            if ((c == 'telefone' || c == 'cnpj_cpf')
            && camposMask[c].el.value.length > camposMask[c].mask[0].length) {
                VMasker(camposMask[c].el).maskPattern(camposMask[c].mask[1]);
            } else {
                VMasker(camposMask[c].el).maskPattern(camposMask[c].mask[0]);
            }
            camposMask[c].el.addEventListener(
                "input",
                inputHandler.bind(undefined, camposMask[c].mask, 14),
                false
            );
        }
    }
}

function campoCepInput(evt) {
    camposMask.cep.el.classList.remove("invalido");
    if (evt.target.value == "") {
        alterarCampos();
        return;
    }
    const cep = evt.target.value;
    if (cep.match(/^\d{5}-\d{3}$/)) {
        const url = endpointCep.replace("{{cep}}", cep);
        toggleCampos(true, camposCep);
        window.fetch(url).then((res) => {
            res.json().then((json) => {
                if (!json.erro) {
                    alterarCampos({
                        address1: `${json.logradouro}, número`,
                        address2: `Bairro ${json.bairro}`,
                        city: json.localidade,
                        state: json.uf,
                    });
                    toggleCampos(false, camposCep);
                    const inputEndereco1 = 
                        document.querySelector('input[name="address1"]');
                    inputEndereco1.focus();
                    inputEndereco1.setSelectionRange(
                        inputEndereco1.value.indexOf('número'),
                        inputEndereco1.value.length
                    )

                } else {
                    alterarCampos();
                    toggleCampos(false, camposCep);
                    camposMask.cep.el.classList.add("invalido");
                }
            });
        });
    }
}

function campoCNPJCPFValidationClear(evt) {
    camposMask.cnpj_cpf.el.classList.remove("invalido");
    camposMask.cnpj_cpf.el.setCustomValidity('')
}

function campoCNPJCPFValidation(evt) {
    if (evt.target.value == "") {
        alterarCampos();
        return;
    }
    const inputVal = evt.target.value;
    if (inputVal.match(/^\d{3}.\d{3}.\d{3}-\d{2}$/)) {
        if (!validarCPF(inputVal)) {
            camposMask.cnpj_cpf.el.classList.add("invalido");
            camposMask.cnpj_cpf.el.setCustomValidity('CPF inválido')
            camposMask.cnpj_cpf.container
                .querySelector('.invalid-feedback')
                .innerHTML = "CPF inválido"
        }
    } else if (inputVal.match(/^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/)) {
        const url = endpointCnpj.replace("{{cnpj}}", VMasker.toNumber(inputVal));
        // console.log(url);
        toggleCampos(true, camposCnpj);
        window.fetch(url, { mode: "cors" }).then((res) => {
            res.json()
                .then((json) => {
                    if (json.status != 'ERROR') {
                        alterarCampos({
                            companyname: json.nome,
                            postcode: VMasker.toPattern(json.cep, "99999-999"),
                            address1: `${json.logradouro}`,
                            address2: `Bairro ${json.bairro}`,
                            city: json.municipio,
                            state: json.uf
                        });
                        toggleCampos(false, camposCnpj);
                    } else {
                        alterarCampos();
                        toggleCampos(false, camposCnpj);
                        camposMask.cnpj_cpf.el.classList.add("invalido");
                        camposMask.cnpj_cpf.el.focus()
                        camposMask.cnpj_cpf.el.setCustomValidity('CNPJ inválido ou não existe')
                        camposMask.cnpj_cpf.container
                            .querySelector('.invalid-feedback')
                            .innerHTML = "CNPJ inválido ou não existe"
                    }
                })
                .catch((e) => {
                    console.error(e);
                    toggleCampos(false, camposCnpj);
                    camposMask.cnpj_cpf.el.setCustomValidity('CNPJ inválido ou não existe')
                });
        });
    } else {
        camposMask.cnpj_cpf.el.classList.add("invalido");
        camposMask.cnpj_cpf.el.setCustomValidity('Informe um CPF ou CNPJ válido')
        camposMask.cnpj_cpf.container
            .querySelector('.invalid-feedback')
            .innerHTML = "Informe um CPF ou CNPJ válido"
    }
}

function campoCPFInput(evt) {
    camposMask.cpf.el.classList.remove("invalido");
    camposMask.cpf.el.setCustomValidity('')
    if (evt.target.value == "") {
        return;
    }
    const cpf = evt.target.value;
    if (cpf.match(/^\d{3}.\d{3}.\d{3}-\d{2}$/)) {
        if (!validarCPF(cpf)) {
            camposMask.cpf.el.classList.add("invalido");
            camposMask.cpf.el.setCustomValidity('CPF inválido')
        }
    }
}

function campoCnpjInput(evt) {
    camposMask.cnpj.el.classList.remove("invalido");
    camposMask.cnpj.el.setCustomValidity('')
    if (evt.target.value == "") {
        alterarCampos();
        return;
    }
    const cnpj = evt.target.value;
    if (cnpj.match(/^\d{2}.\d{3}.\d{3}\/\d{4}-\d{2}$/)) {
        const url = endpointCnpj.replace("{{cnpj}}", VMasker.toNumber(cnpj));
        toggleCampos(true, camposCnpj);
        window.fetch(url, { mode: "cors" }).then((res) => {
            res.json()
                .then((json) => {
                    if (json.status != 'ERROR') {
                        alterarCampos({
                            companyname: json.fantasia != "" ? json.fantasia : json.nome,
                            postcode: VMasker.toPattern(json.cep, "99999-999"),
                            address1: `${json.logradouro}, ${json.numero}`,
                            address2: `Bairro ${json.bairro}`,
                            city: json.municipio,
                            state: json.uf
                        });
                        toggleCampos(false, camposCnpj);
                    } else {
                        alterarCampos();
                        toggleCampos(false, camposCnpj);
                        camposMask.cnpj.el.classList.add("invalido");
                        camposMask.cnpj.el.setCustomValidity('CNPJ inválido ou não existe')
                    }
                })
                .catch((e) => {
                    console.error(e);
                    toggleCampos(false, camposCnpj);
                    camposMask.cnpj.el.setCustomValidity('CNPJ inválido ou não existe')
                });
        });
    }
}

function radioInit() {
    if (window.sessionStorage) {
        const tipo = sessionStorage.getItem('hs_tipocliente')
        if (tipo && camposMask.cpf.el && camposMask.cnpj.el) {
            radioTipoPessoa(tipo, true)
            document.querySelector(`#p-${tipo}`).setAttribute('checked', true)
            window.$(`#p-${tipo}`).iCheck('update');
        }
    }
}

// Seleção de pessoa física/jurídica
function radioTipoPessoa(tipo, manter = false) {
    if (tipo && camposMask.cnpj.el && camposMask.cpf.el) {
        switch (tipo) {
            case "fisica":
                if (!manter) {
                    camposMask.cpf.el.value = ""
                    camposMask.nomeEmpresa.el.value = ""
                }
                camposMask.cnpj.el.disabled = true
                camposMask.cpf.el.disabled = false
                camposMask.cnpj.container.classList.remove("selecionado")
                camposMask.nomeEmpresa.container.classList.remove("selecionado")
                camposMask.cpf.container.classList.add("selecionado")
                if (window.sessionStorage) {
                    sessionStorage.setItem('hs_tipocliente', 'fisica')
                }
                break
            case "juridica":
                if (!manter) {
                    camposMask.cnpj.el.value = ""
                }
                camposMask.cnpj.el.disabled = false
                camposMask.cpf.el.disabled = true
                camposMask.cpf.container.classList.remove("selecionado")
                camposMask.cnpj.container.classList.add("selecionado")
                camposMask.nomeEmpresa.container.classList.add("selecionado")
                if (window.sessionStorage) {
                    sessionStorage.setItem('hs_tipocliente', 'juridica')
                }
                break
        }
    }
}

function estadoSelected(estado, select) {
    if (select.dataset.value == estado) return 'selected'
}

function inserirOptionsEstados() {
    let select = document.querySelector('select#state_select')
    if (select) {
        let stringOptions =
            '<option value="" disabled selected required>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Selecione um estado...</option>'
        estados.forEach(estado => {
            stringOptions += `<option ${estadoSelected(estado.sigla, select) || ''} value="${estado.sigla}">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${estado.nome}</option>`
        });
        select.innerHTML = stringOptions
    }
}

function detectHiddenForm() {
    const isFormHidden = document.querySelector('#containerNewUserSignup')
        .style.display == 'none'
    setRequired(!isFormHidden)
}

function setRequired(state) {
    const ids = [
        'p-juridica',
        'p-fisica',
        'customfield154', // CPF
        'customfield153', // CNPJ
        'state_select'    // Estado
    ]
    ids.forEach(id => {
        if (state) {
            document.querySelector('#' + id)
                .required = true
        } else {
            document.querySelector('#' + id)
                .removeAttribute('required')
        }
    })
}

export {
    initVMasker,
    campoCNPJCPFValidation,
    campoCNPJCPFValidationClear,
    campoCPFInput,
    campoCepInput,
    campoCnpjInput,
    radioInit,
    radioTipoPessoa,
    inserirOptionsEstados,
    detectHiddenForm
}